module.exports = __webpack_public_path__ + "media/img/about-us/team-img-eb2c6c1c964688685b4daefbadda7186.jpg";